import { Component, OnInit, Input } from '@angular/core';
import { GenderPerAgeChartData } from '../../../../../models/chart';
import { UserService } from '../../../../services/user.service';
import { CommonConstant, GenderPerAgeChartYMaxRange, GenderEnum } from '../../../../app.constants';

@Component({
  selector: 'new-gender-per-age-chart',
  templateUrl: './new-gender-per-age-chart.component.html',
  styleUrls: ['./new-gender-per-age-chart.component.scss']
})
export class NewGenderPerAgeChartComponent implements OnInit {

  @Input() chartData: Array<GenderPerAgeChartData>;
  @Input() maxPercent: number;
  @Input() isPlaceholder: boolean | false;
  public leftXAxis: Array<number>;
  public rightXAxis: Array<number>;
  public yAxis: Array<number>;
  public barFullHeight: number;
  public yAxisMaxValue: number;
  constructor(private userService: UserService) { }

  ngOnInit() {
    this.loadYAxisValue();
    this.yAxisMaxValue = Math.max(...this.yAxis);
    this.barFullHeight = CommonConstant.GENDER_PER_AGE_CHART_FULL_HEIGHT;
  }

  private loadYAxisValue() {
    if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_40) {
      this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_50;
    } else if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_65 && this.maxPercent > GenderPerAgeChartYMaxRange.MAX_40) {
      this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_75;
    } else if (this.maxPercent <= GenderPerAgeChartYMaxRange.MAX_90 && this.maxPercent > GenderPerAgeChartYMaxRange.MAX_65) {
      this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_100;
    } else {
      this.yAxis = CommonConstant.GENDER_PER_AGE_PERCENTAGE.RANGE_125;
    }
  }

  get barMaleColor() {
    return this.userService.chartColors[GenderEnum.MALE];
  }

  get barFemaleColor() {
    return this.userService.chartColors[GenderEnum.FEMALE];
  }

  getBarHeight(value) {
    return value >= this.yAxisMaxValue ? CommonConstant.GENDER_PER_AGE_CHART_FULL_HEIGHT : (value / this.yAxisMaxValue) * 100;
  }

  formatRangeVaule(range: string) {
    let formatedRange;
    if (range.indexOf(CommonConstant.GENDER_PER_AGE_HIGHEST_RANGE_VALUE) >= 0) {
      formatedRange = CommonConstant.GENDER_PER_AGE_CHART_LAST_RANGE_VALUE;
    } else {
      formatedRange = range.replace('-', ' - ');
    }
    return formatedRange;
  }

}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/new-gender-per-age-chart/new-gender-per-age-chart.component.ts